"use client";

import { motion } from "framer-motion";

import { useEffect, useState } from "react";
import { FAQSection } from "@/components/common/FAQSection";
import { CommunitySection } from "@/components/common/CommunitySection";
import Fetures from "@/components/protocol/fetures";

export default function BlokCapitalProtocol() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);


  if (!mounted) {
    return null; // or a loading state
  }
  return (
    <main className="overflow-hidden">
      {/* Hero Section */}
      <section className=" md:h-screen h-[80vh] ">
        {/* Dynamic Background */}
        <div className="absolute inset-0 bg-white">
          {/* Soft Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-gray-200 via-white to-indigo-200/30" />

          {/* Animated Grid */}
          <div className="absolute inset-0 opacity-20">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px),
                           linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)`,
                backgroundSize: "4rem 4rem",
              }}
            />
          </div>

          {/* Animated Circles */}
          <motion.div
            animate={{
              scale: [1, 1.1, 1],
              rotate: [0, 90, 0],
              opacity: [0.1, 0.3, 0.1],
            }}
            transition={{
              duration: 12,
              repeat: Infinity,
              ease: "linear",
            }}
            className="absolute top-1/4 left-1/4 w-[70vw] sm:w-[24rem] h-[70vw] sm:h-[24rem] rounded-full hidden md:block"
            style={{
              background:
                "radial-gradient(circle, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 70%)",
              filter: "blur(30px)",
            }}
          />

          <motion.div
            animate={{
              scale: [1.2, 1, 1.2],
              rotate: [90, 0, 90],
              opacity: [0.2, 0.4, 0.2],
            }}
            transition={{
              duration: 15,
              repeat: Infinity,
              ease: "linear",
            }}
            className="absolute bottom-1/4 right-1/4 w-[80vw] sm:w-[30rem] h-[80vw] sm:h-[30rem] rounded-full "
            style={{
              background:
                "radial-gradient(circle, rgba(0,0,255,0.1) 0%, rgba(0,0,255,0) 70%)",
              filter: "blur(40px)",
            }}
          />

          {/* Floating Elements */}
          <div className="absolute inset-0 ">
            {[...Array(20)].map((_, i) => (
              <motion.div 
                key={i}
                initial={{
                  x: Math.random() * window.innerWidth,
                  y: Math.random() * window.innerHeight,
                  scale: Math.random() * 0.5 + 0.5,
                  opacity: Math.random() * 0.2 + 0.1,
                }}
                animate={{
                  y: [null, Math.random() * -50],
                  opacity: [null, Math.random() * 0.2 + 0.1],
                }}
                transition={{
                  duration: Math.random() * 5 + 5,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut",
                }}
                className="absolute w-2 h-2 bg-indigo-200 rounded-full"
                style={{
                  filter: "blur(1px)",
                }}
              />
            ))}
          </div>

          {/* Glowing Lines */}
          <motion.div
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 0.2 }}
            transition={{
              duration: 3,
              repeat: Infinity,
              repeatType: "reverse",
            }}
            className="absolute inset-0 hidden md:block "
          >
            <svg
              className="w-full h-full"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              <motion.path
                d="M0,50 Q25,0 50,50 T100,50"
                stroke="url(#gradient)"
                strokeWidth="0.2"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 3, repeat: Infinity }}
              />
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#4c6ef5" />
                  <stop offset="50%" stopColor="#6a5acd" />
                  <stop offset="100%" stopColor="#ff1493" />
                </linearGradient>
              </defs>
            </svg>
          </motion.div>
        </div>

        {/* Content */}
        <div className="relative z-10 h-full flex flex-col justify-center items-center">
          <div className="text-center px-4 max-w-5xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="mb-8 relative"
            >
              <div className="inline-block">
                <motion.span
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  className="inline-block px-6 py-2 rounded-full bg-gradient-to-r from-indigo-200/40 via-teal-200/30 to-pink-200/40 border border-indigo-400/60 text-sm font-medium text-indigo-500 mb-6 relative z-10"
                >
                  BLOK CAPITAL
                </motion.span>
              </div>
              <div className="relative">
                {/* Animated background elements */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: [0.3, 0.6, 0.3],
                    rotate: [0, 180, 360],
                  }}
                  transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute -top-20 -left-20 w-40 h-40 bg-gradient-to-r from-indigo-400/30 to-teal-400/30 rounded-full blur-3xl"
                />
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: [0.3, 0.7, 0.3],
                    rotate: [360, 180, 0],
                  }}
                  transition={{
                    duration: 8,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-l from-pink-400/30 to-indigo-500/30 rounded-full blur-3xl"
                />
                <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold relative">
                  <span className="relative">
                    <span className="absolute -inset-1 bg-gradient-to-r from-pink-600/30 via-teal-400/30 to-indigo-500/30 blur-2xl rounded-2xl" />
                    <span className="relative bg-gradient-to-r from-indigo-400 via-teal-300 to-pink-400 bg-clip-text text-transparent">
                      PROTOCOL
                    </span>
                  </span>
                </h1>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="space-y-6"
            >
              <h2 className="text-2xl md:text-3xl lg:text-4xl text-black font-light">
                A Community Of Investors And Portfolio Managers
              </h2>
              <p className="text-lg text-gray-700 max-w-2xl mx-auto">
                Our protocol is built to unlock the full potential of
                connections
              </p>
            </motion.div>
          </div>
        </div>
      </section>

    

      <Fetures />

      {/* FAQ Section */}
      <FAQSection />

      {/* Community Section */}
      <CommunitySection />
    </main>
  );
}